import { useEffect, useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "assets/theme/admin_form.css";

const AddCategory = () => {
  const navigate = useNavigate();
  const [categoryName, setCategoryName] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [departments, setDepartments] = useState([]);
  const [defaultPriority, setDefaultPriority] = useState("MEDIUM");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const res = await apiFetch("super_admin/list_department");
      setDepartments(res.departments || res);
    } catch (error) {
      alert(error.message);
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!departmentId) {
      newErrors.departmentId = "Please select a department";
    }
    if (!categoryName.trim()) {
      newErrors.categoryName = "Category name is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    try {
      await apiFetch("super_admin/add_category", {
        method: "POST",
        body: JSON.stringify({
          category_name: categoryName,
          department_id: departmentId,
          default_priority: defaultPriority,
        }),
      });

      alert("Category added successfully");
      navigate("/category_list");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                🏷 नवीन प्रकार जोडा (Add New Category)
              </h4>
              <small className="text-white-50">Create a complaint category and map it to a department</small>
            </div>
          </div>

          <Link to="/category_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Category List
          </Link>
        </div>

        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row g-4">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Department <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select ${errors.departmentId ? "is-invalid" : ""}`}
                    value={departmentId}
                    onChange={(e) => {
                      setDepartmentId(e.target.value);
                      if (errors.departmentId) setErrors((prev) => ({ ...prev, departmentId: "" }));
                    }}
                  >
                    <option value="">Select Department</option>
                    {departments.map((dept) => (
                      <option key={dept.department_id} value={dept.department_id}>
                        {dept.department_name}
                      </option>
                    ))}
                  </select>
                  {errors.departmentId ? (
                    <small className="text-danger d-block mt-1">{errors.departmentId}</small>
                  ) : (
                    <small className="text-muted d-block mt-1">
                      Complaints under this category will be assigned to this department.
                    </small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Category Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.categoryName ? "is-invalid" : ""}`}
                    placeholder="e.g. Garbage Collection"
                    value={categoryName}
                    onChange={(e) => {
                      setCategoryName(e.target.value);
                      if (errors.categoryName) setErrors((prev) => ({ ...prev, categoryName: "" }));
                    }}
                  />
                  {errors.categoryName && (
                    <small className="text-danger d-block mt-1">{errors.categoryName}</small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Default Priority</label>
                  <select
                    className="form-select"
                    value={defaultPriority}
                    onChange={(e) => setDefaultPriority(e.target.value)}
                  >
                    <option value="LOW">Low</option>
                    <option value="MEDIUM">Medium</option>
                    <option value="HIGH">High</option>
                  </select>
                  <small className="text-muted">
                    This priority will be auto-assigned to complaints in this category.
                  </small>
                </div>
              </div>

              <div className="mt-4 text-end">
                <button type="submit" className="btn btn-primary px-5" disabled={loading} style={{ fontSize: "0.85rem" }}>
                  {loading ? "Saving..." : "Save Category"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddCategory;
